module.exports = __webpack_public_path__ + "static/media/eventpage-3rd.2650ecc6.svg";